/**
 * Sugestões de Fornecedor/Cliente digitando CNPJ, nome ou código: remove repetidos (o mesmo parceiro vem das
 * buscas por nome, documento e código) e, quando o termo é só número, coloca primeiro o código exato e depois
 * os códigos que começam com o que foi digitado -- assim o código digitado aparece na hora e continua
 * refinando a cada tecla.
 */
export function ordenarSugestoesParceiro<T extends { codparc?: string | number | null }>(lista: T[], termo: string, limite = 10): T[] {
  const vistos = new Set<string>();
  const unicos = (lista ?? []).filter(p => {
    const c = String(p?.codparc ?? '');
    if (vistos.has(c)) return false;
    vistos.add(c);
    return true;
  });
  const t = (termo ?? '').trim();
  if (/^\d+$/.test(t)) {
    const peso = (p: T) => {
      const c = String(p?.codparc ?? '');
      return c === t ? 0 : c.startsWith(t) ? 1 : 2;
    };
    unicos.sort((a, b) => peso(a) - peso(b)); // sort estável: mantém a ordem original dentro do mesmo peso
  }
  return unicos.slice(0, limite);
}
